import React from 'react';

import LivePersonaCard from '../../cards/LivePersonaCard';

import { RenderUserReferenceType } from './types';

export const renderUserHoverCard: RenderUserReferenceType = (children, options) =>
  (options && <LivePersonaCard {...options}>{children}</LivePersonaCard>) || children;
